






import { SimpleError } from '@simonbackx/simple-errors';
import { InputBox } from "@goodless/components"
import { Component, Prop,Vue, Watch } from "vue-property-decorator";
import { ErrorBox, Validator } from '@simonbackx/simple-error-forms';

@Component({
    components: {
        InputBox
    }
})
export default class VATInput extends Vue {
    @Prop({ default: "" }) 
    title: string;

    @Prop({ default: null }) 
    validator: Validator | null

    VATRaw = "";
    valid = true;

    @Prop({ default: null })
    value!: string | null

    @Prop({ default: true })
    required!: boolean

    @Prop({ default: "" })
    placeholder!: string

    errorBox: ErrorBox | null = null

    @Watch('value')
    onValueChanged(val: string | null) {
        if (val === null) {
            return
        }
        this.VATRaw = val
    }

    mounted() {
        if (this.validator) {
            this.validator.addValidation(this, () => {
                return this.validate()
            })
        }

        this.VATRaw = this.value ?? ""
    }

    destroyed() {
        if (this.validator) {
            this.validator.removeValidation(this)
        }
    }

    async validate() {

        if (!this.required && this.VATRaw.length == 0) {
            this.errorBox = null

            if (this.value !== null) {
                this.$emit("input", null)
            }
            return true
        }
        try {
            const jsvat = await import(/* webpackChunkName: "jsvat" */ 'jsvat');
            const result = jsvat.checkVAT(this.VATRaw, [jsvat.belgium]);
            
            if (!result.isValid) {
                this.errorBox = new ErrorBox(new SimpleError({
                    "code": "invalid_field",
                    "message": "Ongeldig BTW-nummer",
                    "field": "VAT"
                }))

                if (this.value !== null) {
                    this.$emit("input", null)
                }
                return false

            } else {
                const v = result.value ?? this.VATRaw
        
                if (this.value !== v) {
                    this.$emit("input", v)
                }
                this.errorBox = null
                return true
            }
        } catch (e) {
            console.error(e)
            this.errorBox = new ErrorBox(e)
            return false
        }
        
    }
}
